import { useEffect, useState } from 'react';

/**
 * 스크롤 위치에 따라 현재 섹션 ID를 반환하는 훅
 * 뷰포트 중앙에 있는 [data-bg-section] 요소의 sectionId를 반환
 *
 * @returns 현재 뷰포트 중앙에 있는 섹션의 ID (없으면 null)
 */
export const useScrollBackground = (): string | null => {
  const [currentSectionId, setCurrentSectionId] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;

      // 뷰포트 중앙에 있는 요소에서 섹션 찾기
      const element = document.elementFromPoint(centerX, centerY);
      const section = element?.closest('[data-bg-section]');
      const sectionId = section?.getAttribute('data-bg-section') ?? null;

      setCurrentSectionId(sectionId);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return currentSectionId;
};
